/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Page_Title_LeadInputs */

const en_pricing_page_title_lead = /** @type {(inputs: Pricing_Page_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start for free.`)
};

const pl_pricing_page_title_lead = /** @type {(inputs: Pricing_Page_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij za darmo.`)
};

/**
* | output |
* | --- |
* | "Start for free." |
*
* @param {Pricing_Page_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_page_title_lead = /** @type {((inputs?: Pricing_Page_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Page_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_page_title_lead(inputs)
	return en_pricing_page_title_lead(inputs)
});